<template>
  <GenericList api-endpoint="device" ref="GenericList">
    <template v-slot:title>{{ $t('deviceList') }}</template>
    <template v-slot:header>
      <DeviceHeader />
    </template>
    <template v-slot:item="{ item, index }">
      <DeviceItem :item="item" :index="index" @remove-item="removeItem" />
    </template>
  </GenericList>
</template>

<script>
import DeviceHeader from './DeviceHeader.vue';
import DeviceItem from './DeviceItem.vue';
import GenericList from '../generic/GenericSearchList.vue';

export default {
  components: {
    DeviceHeader,
    DeviceItem,
    GenericList,
  },
  methods: {
    removeItem(item) {
      if (this.$refs.GenericList) {
        this.$refs.GenericList.removeItem(item);
      }
    },
  },
};
</script>
